import { RichiestaDTO } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { LinkButton, generatePath } from '@framework/ui';
import React from 'react';

export interface ISubmissionDelegationButtonProps {
  submission: RichiestaDTO | undefined;
}

/**
 * Pulsante per delegare una richiesta
 */
export function SubmissionDelegationButton(
  props: ISubmissionDelegationButtonProps,
) {
  const { submission } = props;
  const { t } = useTranslation();

  if (!submission) {
    return null;
  }

  return (
    <>
      {/* Per visionare il pulsante la richiesta non deve essere inviata */}
      <LinkButton
        type="primary"
        size="large"
        to={generatePath('/richieste/:id/deleghe', {
          id: submission.id ?? '<unknown>',
        })}
      >
        {t('submission.delegation-button', 'Delega la Richiesta')}
      </LinkButton>
    </>
  );
}
